import PaymentsForContactDatagrid from 'src/components/EntityDatagrids/PaymentsForContactDatagrid';

const PaymentsContactPage = () => (<PaymentsForContactDatagrid />);
export default PaymentsContactPage;
